"use client";
import React from "react";
import { Calendar } from "antd";
import type { CalendarProps } from "antd";
import Icon from "components/common/Icon";
import dayjs from "dayjs";
import cx from "classnames";
interface Props extends Omit<CalendarProps<dayjs.Dayjs>, "onChange"> {
  onChange?: (date: dayjs.Dayjs) => void;
}

const CalendarComponent: React.FC<Props> = ({ onChange, ...props }) => {
  const handleChange = (date: dayjs.Dayjs) => {
    onChange?.(date);
  };

  return (
    <div className="w-full px-2 mt-4">
      <Calendar
        headerRender={({ value, type, onChange, onTypeChange }) => {
          const handlePrevMonth = () => {
            onChange(value.clone().subtract(1, "month"));
          };

          const handleNextMonth = () => {
            onChange(value.clone().add(1, "month"));
          };

          return (
            <div className="flex items-center justify-between px-4 py-3">
              <button
                className="p-2 hover:bg-gray-100 rounded-full transition-colors rotate-180"
                onClick={handlePrevMonth}
              >
                <Icon name="arrow-right" size={20} />
              </button>
              <span className="text-base font-medium text-gray-700 uppercase">
                THÁNG {value.format("MM/YYYY")}
              </span>
              <button
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                onClick={handleNextMonth}
              >
                <Icon name="arrow-right" size={20} />
              </button>
            </div>
          );
        }}
        className="rounded-3xl"
        fullscreen={false}
        {...props}
        onChange={handleChange}
      />
    </div>
  );
};

export default CalendarComponent;
